import { useState } from "react";
import { Link } from "react-router";
import translations from '../locales/translations.json';

function t(key) {
  return translations[key] || key;
}

function Element({ setUser, apiCall, setCookie, setToken }) {

    const [error, setError] = useState(null);
    const [orgnrError, setOrgnrError] = useState(null);
    const [momsad, setMomsad] = useState(false);

    const authenticate = async (data) => {

        console.log( 'authenticating with data:', data );

        const { response, error } = await apiCall("POST", "login", {
            email : data.email,
            password: data.password
        });

        if (error) {
            console.error(response);
            setError(error);
            return;
        }

        if (response && response.user) {
            setCookie('token', response.token, { path: '/' });
            // setCookie('user', response.user, { path: '/' });
            setUser(response.user);
            setToken(response.token);
            window.location.href = '/add';
        } 
    };

    // send data to API on form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setOrgnrError(null);

        const formData = new FormData(e.target);
        let data = Object.fromEntries(formData.entries());

        // check if passwords match
        if (data.password !== data['password-confirm']) {
            setError(t('passwords_do_not_match'));
            return;
        }

        // organisationsnummer: 10 digits after stripping non-digits (mirrors server)
        const orgnrDigits = (data.organisationsnummer || '').replace(/\D/g, '');
        if (orgnrDigits.length !== 10) {
            setOrgnrError(t('organisationsnummer_invalid_format'));
            return;
        }

        // check if name, email and password are provided
        if (!data.name || !data.email || !data.password) {
            setError(t('name_email_password_required'));
            return;
        }

        // check that both first and last name are provided (at least two words)
        if (data.name.trim().split(/\s+/).filter(Boolean).length < 2) {
            setError(t('full_name_required'));
            return;
        }

        // if interested_in_meat_return is set to on, set it to true
        if (data.interested_in_meat_return === 'on') {
            data.interested_in_meat_return = true;
        } else {
            data.interested_in_meat_return = false;
        }

        // remove password-confirm from data
        delete data['password-confirm'];

        // check if terms are accepted
        if (!data.terms) {
            setError(t('accept_terms_conditions'));
            return;
        }

        const { response, error, errors } = await apiCall("POST", "register", data);

        if (error) {
            if (errors && errors.organisationsnummer && errors.organisationsnummer[0]) {
                setOrgnrError(errors.organisationsnummer[0]);
            }
            setError(error);
            return;
        }

        if (response && response.user) {
            //wait before redirecting to login
            setTimeout(() => {
                authenticate(data);
            }, 1000);
        } else {
            setError(t('login_failed'));
        }

    };
    

    return (
        <div className="row m-0">
            <div className="col-12 p-0">
                <div className="login-card login-dark">

                    <div className="login-main create-account">
                        <form className="theme-form" onSubmit={handleSubmit}>
                            <h4>{t('create_your_account')}</h4>
                            <p>{t('enter_personal_details')}</p>
                            <div className="form-group">
                                <label className="col-form-label pt-0">{t('your_name')}</label>
                                <input className="form-control" type="text" required name="name" placeholder={t('first_name_placeholder')} />
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('email_address')}</label>
                                <input className="form-control" type="email" required name="email" placeholder={t('email_placeholder')} />
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('password')}</label>
                                <div className="form-input position-relative">
                                    <input className="form-control" type="password" name="password" required placeholder={t('password_placeholder')} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('confirm_password')}</label>
                                <div className="form-input position-relative">
                                    <input className="form-control" type="password" name="password-confirm" required placeholder={t('password_placeholder')} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('phone_number')}</label>
                                <input className="form-control" type="tel" required name="phone" placeholder={t('phone_placeholder')} />
                            </div>  
                            <div className="form-group"> 
                                <div className="form-check form-switch">
                                    <input className="form-check-input" id="interestedInMeatReturn" type="checkbox" role="switch" name="interested_in_meat_return" />
                                    <label className="form-check-label" htmlFor="interestedInMeatReturn">{t('interested_in_meat_return')}</label>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" id="Momsad" type="checkbox" role="switch" name="momsad" checked={momsad} onChange={() => setMomsad(!momsad)} />
                                    <label className="form-check-label" htmlFor="Momsad">{t('momsad')}</label>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="col-form-label">{t('organisationsnummer')}</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    required
                                    name="organisationsnummer"
                                    inputMode="numeric"
                                    pattern="[0-9 \-]*"
                                    placeholder={t('organisationsnummer_placeholder')}
                                />
                                <small className="form-text text-muted">{t('organisationsnummer_helper')}</small>
                                {orgnrError && <div className="text-danger mt-1">{orgnrError}</div>}
                            </div>


                            <div className="form-group">
                                <label className="col-form-label">{t('address')}</label>
                                <input className="form-control" type="text" required name="adress" placeholder={t('address_placeholder')} />
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('postal_code')}</label>
                                <input className="form-control" type="text" required name="postnummer" placeholder={t('postal_code_placeholder')} />
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">{t('city')}</label>
                                <input className="form-control" type="text" required name="postort" placeholder={t('city_placeholder')} />
                            </div>

                            <div className="form-group">
                                <label className="col-form-label">{t('bank_account')}</label>
                                <input className="form-control" type="text" required name="bank_account" placeholder={t('bank_account_placeholder')} />
                            </div>  
                            <div className="form-group">
                                <label className="col-form-label">{t('bank_account_name')}</label>
                                <input className="form-control" type="text" required name="bank_account_name" placeholder={t('bank_account_name_placeholder')} />
                            </div>
                            <div className="form-group mb-0">
                                <div className="form-check">
                                    <input className="checkbox-primary form-check-input" id="checkbox1" type="checkbox" name="terms" />
                                    <label className="text-muted form-check-label" htmlFor="checkbox1">{t('agree_terms_conditions')} <a className="ms-2" href="/terms">{t('privacy_policy')}</a></label>
                                </div>
                                <button className="btn btn-primary btn-block w-100 mt-3" type="submit">{t('create_account')}</button>
                            </div>
                            {error && <div className="alert alert-danger mt-2">{error}</div>}
                            <p className="mt-4 mb-0">{t('already_have_account')}<Link className="ms-2" to="/login">{t('sign_in')}</Link></p>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Element;
